import Page from '@components/Pages/Page';
import { Pages } from '@lib/constants';
import FinalizeParticipants from './FinalizeParticipants';

const FinalizeParticipantsPage = () => {

  return (
    <Page
      pageId={Pages.SESSION_EDIT}
      navPhoto={{ image: '/images/activities/left_sidebar.jpg' }}
      title='Finalize Participant List'
      breadcrumbs={['events', ':event', ':session', 'Finalize Participant List']}
      requireAuth
    >
      <FinalizeParticipants />
    </Page>
  )
};

export default FinalizeParticipantsPage;
